import { createContext } from "react";

export const DropdownMenuContext = createContext({
  open: null,
  setOpen: null,
});
